import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-39" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "frame-40" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-22" }, "Rentabilité accrue"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-23" }, " Optimisez vos ventes et réduisez les coûts avec une gestion efficace de votre inventaire et de vos commandes. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['container-3', `property-1-0-${_ctx.property1}`, _ctx.className])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "badge-euro-sign",
        alt: "Badge euro",
        src: _ctx.badgeEuroSrc
      }, null, 8, _hoisted_2),
      _hoisted_3
    ])
  ], 2))
}